module.exports = __webpack_public_path__ + "media/conversa/ico_sofia30-77aded49.png";